module.exports = __webpack_public_path__ + "images/mobile-navigation.png";